export const UPDATE_SELECTED_VARIANTS =
  'app/VolumeDiscountPage/UPDATE_SELECTED_VARIANTS';

export const UPDATE_VARIANT_SELECTOR_IN_VIEW =
  'app/VolumeDiscountPage/UPDATE_VARIANT_SELECTOR_IN_VIEW';

export const UPDATE_SELECTED_VD_OPTION_INDEX =
  'app/volumeDiscountPage/UPDATE_SELECTED_VD_OPTION_INDEX';

export const UPDATE_SELECTED_VD_OPTION =
  'app/volumeDiscountPage/UPDATE_SELECTED_VD_OPTION';

export const UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES =
  'app/volumeDiscountPage/UPDATE_VD_TOTAL_DISPLAY_OFFER_VALUES';

export const UPDATE_VD_OFFER_THEME =
  'app/volumeDiscountPage/UPDATE_VD_OFFER_THEME';

export const UPDATE_VD_MR_OFFER_ID =
  'app/volumeDiscountPage/UPDATE_VD_MR_OFFER_ID';

export const UPDATE_VD_PRIMARY_PRODUCT =
  'app/volumeDiscountPage/UPDATE_VD_PRIMARY_PRODUCT';
